import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

// Components
import Video from "./Video";

// Context
import { VideosContext } from "../../context/videos";

// Platforms
import { Api } from "../../platforms/api";

// Utils
import { reformatAcfResponse } from "../../utils/fetchUtils";
import { copyToClipboard } from "../../utils/miscUtils";
import { scrollToTop } from "../../utils/scrollUtils";

const VideoContainer = (props) => {
    /**
     * Router Hooks
     */

    const history = useHistory();
    const location = useLocation();
    const { id } = useParams();

    /**
     * useContext
     */

    const { videos } = useContext(VideosContext);

    /**
     * useState
     */

    const [tooltipText, setTooltipText] = useState("Click to copy video link");
    const [video, setVideo] = useState(null);

    /**
     * useEffect
     */

    useEffect(() => {
        scrollToTop();
        if (!video) {
            const { video: locationVideo } = location?.state || {};
            locationVideo ? setVideo(locationVideo) : fetchVideo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * End Hooks
     */

    function copyLinkToClipboard() {
        copyToClipboard(window.location.href);
        setTooltipText("Copied!");
        setTimeout(() => {
            setTooltipText("Click to copy video link");
        }, 3000);
    }

    function fetchVideo() {
        Api.getVideo({ id }, onFetchVideoSuccess, onFetchVideoError);
    }

    function onFetchVideoError(err) {
        history.push("/videos");
    }

    function onFetchVideoSuccess({ headers, body: res }) {
        setVideo(reformatAcfResponse(res));
    }

    return (
        <Video
            {...props}
            copyLinkToClipboard={copyLinkToClipboard}
            history={history}
            tooltipText={tooltipText}
            video={video}
            videos={videos}
        />
    );
};

export default VideoContainer;
